var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AirTrackerPlugin } from '../interface/plugins';
import { SeverityType } from '../constant';
import { canUseResourceTiming, canUseWebVitals } from '../util/index';
// import { CLSMetric } from 'web-vitals/attribution';
// import webVital from 'web-vitals';
export const webVitalsPlugin = new AirTrackerPlugin({
    name: 'webVitalsPlugin',
    setUp: (airTracker) => __awaiter(void 0, void 0, void 0, function* () {
        if (!canUseResourceTiming() || !canUseWebVitals()) {
            return;
        }
        const { onCLS, onFID, onLCP } = yield import('web-vitals');
        const report = (log) => {
            const { name, navigationType, rating, value } = log;
            airTracker.normalLogPipeLine({
                severity: SeverityType.PERFORMANCE,
                eventName: name,
                log: { navigationType, rating, value },
            });
        };
        onCLS(report);
        onFID(report);
        onLCP(report);
    }),
});
